import { render } from "./JiffyPromotionTransfers.vue?vue&type=template&id=438edbd1&scoped=true"
import script from "./JiffyPromotionTransfers.vue?vue&type=script&lang=js"
export * from "./JiffyPromotionTransfers.vue?vue&type=script&lang=js"

import "./JiffyPromotionTransfers.vue?vue&type=style&index=0&id=438edbd1&lang=scss&scoped=true"

import exportComponent from "../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.7.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438edbd1"]])

export default __exports__